import { render, staticRenderFns } from "./SubmissionsStudents.vue?vue&type=template&id=54bb768e&scoped=true&"
import script from "./SubmissionsStudents.vue?vue&type=script&lang=js&"
export * from "./SubmissionsStudents.vue?vue&type=script&lang=js&"
import style0 from "./SubmissionsStudents.vue?vue&type=style&index=0&id=54bb768e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54bb768e",
  null
  
)

export default component.exports